<div *ngIf="treatment" class="contact-upper-component field-font-small">
    <app-treatment-kine [treatment]="treatment" [contact]="contact"></app-treatment-kine>
</div>